import { useState, useEffect } from 'react';
import { getFeedSearch } from '../../service/feedService';
import BetCard from '../betFeed/betCard';
import componentStyles from './search.module.css';
import SmallLoadingAlt from '../global/smallLoadingAlt';
import globalStyles from '../globals.module.css';
import PageView from '../common/pageView';
import AnalyticsService from '../../service/analyticsService';
import { EVENT_SEARCH_PERFORMED } from '../../utils/analyticsConstants';

const Search = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage] = useState(1);
    const [pageSize] = useState(25);

    // Debounce search to prevent too many API calls
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm) {
                handleSearch();
            } else {
                setSearchResults([]);
            }
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const response = await getFeedSearch(searchTerm);
            const { data } = response;

            if (data.success) {
                const items = data.results.feedItems.map((item, index) => ({
                    ...item,
                    id: index + 1
                }));
                setSearchResults(items);
                AnalyticsService.getInstance().track(EVENT_SEARCH_PERFORMED, {
                    searchTerm: searchTerm?.slice(0, 100) ?? '',
                    resultsCount: items.length,
                    hasResults: items.length > 0
                });
            }
        } catch (error) {
            console.error('Error searching bets:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <PageView
            title="Search"
            containerClassName={componentStyles.searchContainer}
            contentClassName={componentStyles.searchContent}
        >
            <section className={`${globalStyles.standardSection} ${componentStyles.searchBarContainer}`}>
                <div className={componentStyles.searchLabel}>Feed index // keyword query</div>
                <input
                    type="text"
                    placeholder="Search bets..."
                    value={searchTerm}
                    onChange={handleInputChange}
                    className={`${globalStyles.standardInput} ${componentStyles.searchInput}`}
                />
            </section>
            <div className={componentStyles.searchResults}>
                {loading ? (
                    <SmallLoadingAlt />
                ) : searchResults.length === 0 && searchTerm ? (
                    <div className={globalStyles.emptyState}>
                        <p>No results found for "{searchTerm}"</p>
                    </div>
                ) : (
                    searchResults.map((bet) => (
                        <BetCard key={bet.id} betCard={bet} prevView={'search'} />
                    ))
                )}
            </div>
        </PageView>
    );
};

export default Search;
